import { render, staticRenderFns } from "./fourquadrants.vue?vue&type=template&id=f960aae4&scoped=true"
import script from "./fourquadrants.vue?vue&type=script&lang=js"
export * from "./fourquadrants.vue?vue&type=script&lang=js"
import style0 from "./fourquadrants.vue?vue&type=style&index=0&id=f960aae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f960aae4",
  null
  
)

export default component.exports